export default function HotelDetails({ children }) {
	return (
		<div className="flex flex-col flex-grow items-start gap-1 p-3">
			{children}
		</div>
	);
}
